// extracted by mini-css-extract-plugin
export default {"general":"Recipe_general__VSU2f","name":"Recipe_name__qqtIZ","img":"Recipe_img__ytX5j","star":"Recipe_star__kmf9B"};